module.exports = __webpack_public_path__ + "img/291.b03a7eb5.png";